<template>
  <div>
    <div
      class="row align-items-center w-100"
      v-if="task.type === 'identity.touchpoint'"
    >
      <div class="col-12 col-lg-2 icon">
        <template v-if="task.data.provider !== 'garmin-connect'">
          <i
            :class="task.data.presenter.icon.class"
            v-if="task.data.presenter.icon.type === 'icon'"
          ></i>
          <img
            :class="task.data.presenter.icon.class"
            :src="task.data.presenter.icon.src"
            :alt="task.data.label"
            v-if="task.data.presenter.icon.type === 'image'"
          />
        </template>
        <template v-else>
          <div v-html="icons.garmin" class="garmin-connect-logo"></div>
        </template>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Connetti il tuo") }}
        <strong v-cloak>{{ task.data.presenter.label }}</strong>
        {{ $t("account") }}
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <button
          @click="getSocialLoginLink(task.data.provider)"
          class="btn"
          v-cloak
        >
          + {{ task.data.points }} {{ $t("coins") }}
        </button>
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'twitter.follow'"
      @click="
        gotoPageMessage(
          $event,
          'https://www.twitter.com/intent/follow?screen_name=' +
            task.data.label,
          'blank',
          {
            type: 'waiting',
            title: $t('Segui l\'account Twitter'),
            text: $t('I punti verranno assegnati in 24 ore')
          }
        )
      "
    >
      <div class="col-12 col-lg-2 icon">
        <i class="fab fa-twitter" style="color:#2aa3f0"></i>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Segui l'account Twitter") }}
        <strong v-cloak>{{ "@" + task.data.label }}</strong>
        <br />
        <small style="font-style:italic">{{
          $t("I punti verranno assegnati in 24 ore")
        }}</small>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a
          :href="
            'https://www.twitter.com/intent/follow?screen_name=' +
              task.data.label
          "
          target="_blank"
          class="btn btn-not-spinner"
          v-cloak
          >+ {{ task.data.points }} {{ $t("coins") }}</a
        >
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'twitter.retweet'"
      @click="
        gotoPageMessage(
          $event,
          'https://www.twitter.com/' + task.data.label,
          'blank',
          {
            type: 'waiting',
            title: $t('Ritwitta l\'account'),
            text: $t('I punti verranno assegnati in 24 ore')
          }
        )
      "
    >
      <div class="col-12 col-lg-2 icon">
        <i class="fab fa-twitter" style="color:#2aa3f0"></i>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Ritwitta l'account ") }}
        <strong v-cloak>{{ "@" + task.data.label }}</strong>
        <br />
        <small style="font-style:italic">{{
          $t("I punti verranno assegnati in 24 ore")
        }}</small>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a
          :href="'https://www.twitter.com/' + task.data.label"
          target="_blank"
          class="btn btn-not-spinner"
          v-cloak
          >+ {{ task.data.points }} {{ $t("coins") }}</a
        >
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'twitter.hashtag'"
      @click="
        gotoPageMessage(
          $event,
          'https://twitter.com/intent/tweet?hashtags=' + task.data.label,
          'blank',
          {
            type: 'waiting',
            title: $t('Twitta con l\'hashtag'),
            text: $t('I punti verranno assegnati in 24 ore')
          }
        )
      "
    >
      <div class="col-12 col-lg-2 icon">
        <i class="fab fa-twitter" style="color:#2aa3f0"></i>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Twitta con l'hashtag") }}
        <strong v-cloak>{{ "#" + task.data.label }}</strong>
        <br />
        <small style="font-style:italic">{{
          $t("I punti verranno assegnati in 24 ore")
        }}</small>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a
          href="https://www.twitter.com/"
          target="_blank"
          class="btn btn-not-spinner"
          v-cloak
          >+ {{ task.data.points }} {{ $t("coins") }}</a
        >
      </div>
    </div>

    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'instagram.follow'"
      @click="
        gotoPageMessage(
          $event,
          'https://www.instagram.com/' + task.data.label,
          'blank',
          {
            type: 'waiting',
            title: $t('Segui l\'account Instagram'),
            text: $t('I punti verranno assegnati in 24 ore')
          }
        )
      "
    >
      <div class="col-12 col-lg-2 icon">
        <i class="fab fa-instagram" style="color:#c32aa3"></i>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Segui l'account Instagram") }}
        <strong v-cloak>{{ "@" + task.data.label }}</strong>
        <br />
        <small style="font-style:italic">{{
          $t("I punti verranno assegnati in 24 ore")
        }}</small>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a
          :href="'https://www.instagram.com/' + task.data.label"
          target="_blank"
          class="btn btn-not-spinner"
          v-cloak
          >+ {{ task.data.points }} {{ $t("coins") }}</a
        >
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'instagram.tag'"
      @click="
        gotoPageMessage($event, 'https://www.instagram.com/', 'blank', {
          type: 'waiting',
          title: $t('Hai Taggato l\'account @'),
          text: $t('I punti verranno assegnati in 24 ore')
        })
      "
    >
      <div class="col-12 col-lg-2 icon">
        <i class="fab fa-instagram" style="color:#c32aa3"></i>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Hai Taggato l'account @") }}
        <strong v-cloak>{{ "@" + task.data.label }}</strong>
        <br />
        <small style="font-style:italic">{{
          $t("I punti verranno assegnati in 24 ore")
        }}</small>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a
          href="https://www.instagram.com/"
          target="_blank"
          class="btn btn-not-spinner"
          v-cloak
          >+ {{ task.data.points }} {{ $t("coins") }}</a
        >
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'instagram.hashtag'"
      @click="
        gotoPageMessage($event, 'https://www.instagram.com/', 'blank', {
          type: 'waiting',
          title: $t('Hai condiviso su Instagram con l\'hashtag #'),
          text: $t('I punti verranno assegnati in 24 ore')
        })
      "
    >
      <div class="col-12 col-lg-2 icon">
        <i class="fab fa-instagram" style="color:#c32aa3"></i>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Hai condiviso su Instagram con l'hashtag #") }}
        <strong v-cloak>{{ "#" + task.data.hashtag }}</strong>
        <br />
        <small style="font-style:italic">{{
          $t("I punti verranno assegnati in 24 ore")
        }}</small>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a
          href="https://www.instagram.com/"
          target="_blank"
          class="btn btn-not-spinner"
          v-cloak
          >+ {{ task.data.points }} {{ $t("coins") }}</a
        >
      </div>
    </div>

    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'athena.facebook'"
      @click="gotoPage('/link/' + task.data.provider)"
    >
      <div class="col-12 col-lg-2 icon">
        <i
          :class="task.data.presenter.icon.class"
          v-if="task.data.presenter.icon.type === 'icon'"
        ></i>
        <img
          :class="task.data.presenter.icon.class"
          :src="task.data.presenter.icon.src"
          :alt="task.data.label"
          v-if="task.data.presenter.icon.type === 'image'"
        />
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Connetti il tuo") }}
        <strong v-cloak>{{ task.data.presenter.label }}</strong>
        {{ $t("account") }}
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a :href="'/link/' + task.data.provider" class="btn" v-cloak
          >+ {{ task.data.points }} {{ $t("coins") }}</a
        >
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'answer.instantwin'"
      @click="$router.push('/instantwin/' + task.data.contest_id)"
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.instantwin"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Gioca al quiz") }}
        <br />
        <strong>{{ task.data.title }}</strong>
        <br />
        <i v-if="task.data.claim" style="color: red">{{ task.data.claim }}</i>
      </div>
      <div
        class="col-12 col-lg-3 text-center cta"
        @click="$router.push('/instantwin/' + task.data.contest_id)"
      >
        <a class="btn" v-cloak
          >+ {{ task.data.max_points }} {{ $t("Coins massimi") }}</a
        >
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'instantwin.random'"
      @click="$router.push('/instantwinRandom/' + task.data.id)"
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.instantwin"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Gioca all'Instantwin") }}
        <br />
        <strong>{{ task.data.title }}</strong>
        <br />
        <i v-if="task.data.claim" style="color: red">{{ task.data.claim }}</i>
      </div>
      <div
        class="col-12 col-lg-3 text-center cta"
        @click="$router.push('/instantwin/' + task.data.contest_id)"
      >
        <a class="btn" v-cloak>+ {{ task.data.points }} {{ $t("Coins") }}</a>
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'answer.question'"
      @click="gotoPage('/survey/' + task.data.id)"
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.question"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Rispondi alla domanda") }}
        <br />
        <strong v-cloak>{{ getQuestionFromTask(task) }}</strong>
        <br />
        <i v-if="task.data.claim" style="color: red">{{ task.data.claim }}</i>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a :href="'/survey/' + task.data.id" class="btn" v-cloak
          >+ {{ task.data.points }} {{ $t("coins") }}</a
        >
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'answer.survey'"
      @click="$router.push('/survey/' + task.data.id)"
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.survey"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Partecipa al sondaggio") }}
        <br />
        <strong v-cloak>{{ task.data.title }}</strong>
        <br />
        <i v-if="task.data.claim" style="color: red">{{ task.data.claim }}</i>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a class="btn" v-cloak>+ {{ task.data.points }} {{ $t("coins") }}</a>
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'prediction'"
      @click="$router.push('/prediction/' + task.data.id)"
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.survey"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Partecipa al pronostico") }}
        <br />
        <strong v-cloak>{{ task.data.title }}</strong>
        <br />
        <i v-if="task.data.claim" style="color: red">{{ task.data.claim }}</i>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a class="btn" v-cloak>+ {{ task.data.points }} {{ $t("coins") }}</a>
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'mobile.verified'"
      @click="$router.push('/verify/mobile')"
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.phone"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Verifica") }}
        <strong>{{ $t("il numero di cellulare") }}</strong>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <button class="btn" v-cloak>
          + {{ task.data.points }} {{ $t("coins") }}
        </button>
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'email.verified'"
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.mail"></div>
      </div>
      <div class="col-12 col-md-7 description">
        {{ $t("Verifica") }}
        <strong>{{ $t("la mail") }}</strong>
      </div>
      <div class="col-12 col-md-3 text-center cta">
        <a href="#" class="btn" v-cloak
          >+ {{ task.data.points }} {{ $t("coins") }}</a
        >
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'set.password'"
      @click="$router.push('/settings/profile')"
    >
      <div class="col-12 col-lg-2 icon">
        <i class="fas fa-key text-primary"></i>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Imposta la tua") }}
        <strong>{{ $t("password") }}</strong>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a href="/settings/profile#settings-tab" class="btn" v-cloak>{{
          $t("Metti il tuo account in sicurezza")
        }}</a>
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'invite.friend'"
      @click="$router.push('/invite')"
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.mgm"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Invita un amico") }}
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <router-link v-cloak class="btn" to="/invite"
          >+ {{ task.data.points }} {{ $t("coins") }}</router-link
        >
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'customevent.external'"
      @click="goToExternalEvent(task)"
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.external"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ task.data.text }}
        <br />
        <i v-if="task.data.claim" style="color: red">{{ task.data.claim }}</i>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a @click="goToExternalEvent(task)" class="btn" v-cloak>{{
          task.data.btn || "GIOCA"
        }}</a>
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'customevent.download'"
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.download"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Scarica il file") }}
        <br />
        <strong>{{ task.data.text }}</strong>
        <br />
        <i v-if="task.data.claim" style="color: red">{{ task.data.claim }}</i>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a
          @click="downloadFile(task.data.id)"
          target="_blank"
          :href="task.data.link"
          class="btn"
          v-cloak
          >{{ task.data.btn }}</a
        >
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'customevent.video'"
      @click="
        $router.push({
          path: `video/${task.data.id}`
        })
      "
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.download"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Guarda il video") }}
        <br />
        <strong>{{ task.data.text }}</strong>
        <br />
        <i v-if="task.data.claim" style="color: red">{{ task.data.claim }}</i>
      </div>
      <div class="col-12 col-lg-3 text-center cta">
        <a class="btn" v-cloak>{{ task.data.btn }}</a>
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'information.read'"
      @click="getInformation(task.data)"
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.information"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        {{ $t("Conferma di aver letto") }}
        <br />
        <strong>{{ task.data.title }}</strong>
        <br />
        <i v-if="task.data.claim" style="color: red">{{ task.data.claim }}</i>
      </div>
      <div
        class="col-12 col-lg-3 text-center cta"
        @click="getInformation(task.data)"
      >
        <a class="btn" v-cloak>+ {{ task.data.points }} {{ $t("coins") }}</a>
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'agreement.request'"
      @click="
        $router.push({
          name: 'profileSettings',
          params: { preselectedTab: 'privacy' }
        })
      "
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.notifications"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        <template v-if="task.data.label">{{ task.data.label }}</template>
        <template v-else
          >Placeholder</template
        >
        <br />
        <i v-if="task.data.claim" style="color: red">{{ task.data.claim }}</i>
      </div>
      <div
        class="col-12 col-lg-3 text-center cta"
        @click="
          $router.push({
            name: 'profileSettings',
            params: { preselectedTab: 'privacy' }
          })
        "
      >
        <a class="btn" v-cloak>
          <template v-if="task.data.points > 0">
            + {{ task.data.points }} {{ $t("coins") }}
          </template>
          <template v-else>
            {{ $t("Aggiorna ora!") }}
          </template>
        </a>
      </div>
    </div>
    <div
      class="row align-items-center w-100"
      v-else-if="task.type === 'insert.code'"
      @click="
        $router.push({
          path: '/code'
        })
      "
    >
      <div class="col-12 col-lg-2 icon">
        <div v-html="icons.notifications"></div>
      </div>
      <div class="col-12 col-lg-7 description">
        <strong>{{ $t("Inserisci il codice") }}</strong>
        <br />
        <i v-if="task.data.claim" style="color: red">{{ task.data.claim }}</i>
      </div>
      <div
        class="col-12 col-lg-3 text-center cta"
        @click="
          $router.push({
            path: '/code'
          })
        "
      >
        <a class="btn" v-cloak>
          <template>
            {{ $t("Inserisci") }}
          </template>
        </a>
      </div>
    </div>
    <div class="row align-items-center w-100" v-else>
      <div class="col-12 col-lg-2 icon">icon</div>
      <div class="col-12 col-lg-7 description">{{ task }}</div>
      <div class="col-12 col-lg-3 text-center cta">
        <a href="#" class="btn" v-cloak
          >+ {{ task.data.points }} {{ $t("coins") }}</a
        >
      </div>
    </div>
    <information-modal
      @closeInformationModal="closeInformationModal"
      @readInformation="readInformation"
      v-if="showInformationModal"
      :content="currentInformationContent"
      :title="currentInformationTitle"
      :cta="currentInformationCta"
    ></information-modal>
  </div>
</template>
<script>
import iconInstantwin from "./svg/fnz_instant-win.svg";
import iconMobilePhone from "./svg/fnz_num-telefono.svg";
import iconMail from "./../../assets/svg/fnz_mail.svg";
import iconQuestion from "./../../assets/svg/fnz_question.svg";
import iconSurvey from "./../../assets/svg/fnz_survey.svg";
import iconMgm from "./../../assets/svg/fnz_mgm.svg";
import iconDownload from "./../../assets/svg/fnz_download.svg";
import iconEvent from "./../../assets/svg/fnz_event.svg";
import iconInformation from "./../../assets/svg/fnz_information.svg";
import iconGarmin from "./../../assets/svg/garmin_connect_logo.svg";
import iconNotifications from "./../../assets/svg/fnz_notifications.svg";
import _ from "lodash";
import informationModal from "../Information";
import Cookies from "js-cookie";
import parseDomain from "parse-domain";

export default {
  props: {
    task: { default: null },
    messages: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      icons: {
        instantwin: iconInstantwin,
        phone: iconMobilePhone,
        mail: iconMail,
        question: iconQuestion,
        survey: iconSurvey,
        mgm: iconMgm,
        download: iconDownload,
        external: iconEvent,
        information: iconInformation,
        garmin: iconGarmin,
        notifications: iconNotifications
      },
      showInformationModal: false,
      currentInformationId: null,
      currentInformationContent: null,
      currentInformationCta: null
    };
  },
  components: {
    informationModal
  },
  computed: {
    currentTenant() {
      return window.location.protocol + "//" + window.location.host;
    }
  },
  methods: {
    goToExternalEvent(task) {
      window.location =
        task.data.link +
        "?event_id=" +
        task.data.id +
        "&user_id=" +
        this.$store.state.user.id +
        "&back_to=" +
        this.currentTenant;
    },
    gotoPage(page, target) {
      if (target && target === "blank") {
        window.open(page, "_blank");
        return;
      }
      window.location = page;
    },
    gotoPageMessage(e, page, target, message) {
      e.preventDefault();
      this.messages.push(message);
      if (target && target === "blank") {
        window.open(page, "_blank");
        return;
      }
      window.location = page;
    },
    getSocialLoginLink(provider) {
      this.$http
        .get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/" +
            provider +
            "/socialLoginUrl"
        )
        .then(response => {
          const parsedDomain = parseDomain(window.location.hostname);
          if (response.data.data.url) {
            Cookies.set("fanize_social_fallback", window.location.hostname, {
              domain: "." + parsedDomain.domain + "." + parsedDomain.tld
            });
            Cookies.set(
              "fanize_social_token",
              this.$store.state.authorization.access_token,
              { domain: "." + parsedDomain.domain + "." + parsedDomain.tld }
            );
            window.location = response.data.data.url;
          }
        });
    },
    downloadFile(taskId) {
      this.$http({
        url:
          "/api/v1/campaigns/" +
          this.$store.state.campaign.id +
          "/events/" +
          taskId +
          "/download",
        method: "GET"
      }).then(response => {
        // let fileName = _.get(
        //   response,
        //   "headers.content-disposition",
        //   ""
        // ).replace("attachment; filename=", "");
        // let a = document.createElement("a");
        // document.body.appendChild(a);
        // a.style = "display: none";
        // const blob = new Blob([response.data], { type: "octet/stream" }),
        //   url = window.URL.createObjectURL(blob);
        // a.href = url;
        // a.download = fileName;
        // a.click();
        // window.URL.revokeObjectURL(url);
        this.$store.dispatch("getUserTasks");
        this.$store.dispatch("getUnreadMessages");
      });
    },
    getQuestionFromTask(task) {
      return _.get(task, "data.title", "{}");
    },
    async getInformation(task) {
      this.$store.commit("showSpinner");

      this.currentInformationId = task.id;
      this.currentInformationTitle = task.title;

      try {
        let response = await this.$http.get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/information/" +
            task.id
        );
        this.currentInformationContent = _.get(
          response,
          "data.data.content",
          ""
        );
        this.currentInformationCta = _.get(response, "data.data.cta", "");
        this.showInformationModal = true;
      } catch {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    },
    closeInformationModal() {
      this.$store.dispatch("getUserInfo");
      this.$store.dispatch("getUserTasks");
      this.$store.dispatch("getUnreadMessages");
      this.currentInformationId = null;
      this.currentInformationTitle = null;
      this.currentInformationContent = null;
      this.currentInformationCta = null;
      this.showInformationModal = false;
    },
    async readInformation() {
      this.$store.commit("showSpinner");
      try {
        let response = await this.$http.post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/information/" +
            this.currentInformationId
        );
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "waiting",
          title: "Something went wrong",
          text: "Please retry"
        });
      }

      this.$store.commit("hideSpinner");
    }
  }
};
</script>
